import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99984 15.8333V4.16667M9.99984 4.16667L4.1665 10M9.99984 4.16667L15.8332 10",
		stroke: "currentColor",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUpArrow;
